import {memo} from 'react';

function Dashboard() {
  return null
}


export default memo(Dashboard);